import React from 'react';

import { cn } from '@/lib/cn';

export interface SoftPillProps {
  /** Tailwind tone classes - light tinted background + readable dark/colored text. */
  className: string;
  /** Render a leading status dot. */
  dot?: boolean;
  /** Dot colour class (defaults to currentColor). */
  dotClassName?: string;
  children: React.ReactNode;
}

/**
 * Soft "subtle" pill - light tinted background with dark/colored text, the
 * status/role badge style used across admin list screens (matches the handoff
 * design). The @utazzo/ui Badge primitive is solid-only, so this lives here as
 * the shared soft variant. Pair with a tone map per feature (role, status, …).
 */
export const SoftPill = ({
  className,
  dot,
  dotClassName,
  children,
}: SoftPillProps): React.JSX.Element => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
      className,
    )}
  >
    {dot && (
      <span className={cn('h-1.5 w-1.5 rounded-full', dotClassName ?? 'bg-current')} aria-hidden />
    )}
    {children}
  </span>
);
